<template>
  <v-dialog
    v-model="showResultsLoginInfoOpen"
    :fullscreen="$vuetify.display.mobile"
    :width="$vuetify.display.mobile ? '100%' : '588px'"
    class="show-results-login-modal"
  >
    <v-card class="px-4 d-flex flex-column" :width="$vuetify.display.mobile ? '100%' : '588px'">
      <div class="header d-flex flex-row justify-space-between align-center">
        <div class="modal-header mt-4 mb-5">{{ $t('results.to_see_results_header') }}</div>
        <v-btn flat icon color="transparent" size="x-small" class="modal-close" @click="showResultsLoginInfoOpen = false">
          <v-icon color="primary" size="24" icon="mdi-close"></v-icon>
        </v-btn>
      </div>
      <div class="modal-text mb-0 mb-md-10">
        {{ $t('results.to_see_results_text') }}
      </div>
      <v-spacer v-if="$vuetify.display.mobile"></v-spacer>
      <div class="modal-buttons text-right">
        <v-btn
          height="40"
          :width="$vuetify.display.mobile ? '100%' : 'auto'"
          color="primary"
          flat
          rounded
          class="mb-4 mr-md-4 ml-md-0 px-6"
          @click="redirect()"
        >{{ $t('user.login_btn') }}</v-btn>
        <v-btn
          height="40"
          :width="$vuetify.display.mobile ? '100%' : 'auto'"
          color="primary"
          flat
          rounded
          class="mb-4 ml-md-0 px-6"
          @click="goToRegistration()"
        >{{ $t('user.register_btn') }}</v-btn>
      </div>
    </v-card>
  </v-dialog>
  <div v-if="sidebar && !store.getters['resultsModule/getSearchForSimilar']" class="search-header my-8 mb-md-12 mt-md-0 text-left text-md-center pa-4 pa-md-0 invicta">
    <div class="search-header-main mb-2">
      {{ $t('search.search_header_base_main') }}
    </div>
    <div class="search-header-sub">
      {{ $t('search.search_header_base_sub') }}
    </div>
  </div>
  <v-container id="search-container" :class="$vuetify.display.mobile ? 'mobile' : 'pa-8 mb-0'"
    v-if="this.$route.name != 'resultsView' || !store.getters['resultsModule/getSearchForSimilar']">
    <v-row v-if="sidebar && !store.getters['resultsModule/getSearchForSimilar']">
      <v-col>
        <div v-if="isSidebarToSearchResultsPage()" class="text-left pa-4 pb-md-2 filters_header">
          {{ $t('search.filters_header') }}
        </div>
        <div v-if="isSidebarToSearchResultsPage()" class="text-left pa-4 pb-md-6 pt-0 filters_header_label">
          {{ $t('search.filters_header_label') }}
        </div>
      </v-col>
    </v-row>
    <v-row v-if="!sidebar" class="pa-4 pa-md-0">
      <v-col :cols="12">
        <div class="text-left choose_material_header" :class="isSidebarToSearchResultsPage() ? 'mt-10 mb-6' : 'mt-0 mt-md-0 ml-0 ml-md-2 pb-4'">
          {{ $t('search.choose_material_header') }}
        </div>
      </v-col>
      <v-col :cols="12">
        <div v-if="!sidebar" class="text-left" :class="isSidebarToSearchResultsPage() ? 'mt-10 mb-6' : 'mt-0 mt-md-0 ml-0 ml-md-2 mb-12'">
          {{ $t('search.choose_material_header_label') }}
        </div>
      </v-col>
      <v-col :cols="12">
        <h3 v-if="!sidebar" class="text-left step_header_label" :class="isSidebarToSearchResultsPage() ? 'mt-10 mb-6' : 'mt-0 mt-md-0 ml-0 ml-md-2 mb-0'">
          {{  $t('search.step_1_header_label') }}
        </h3>
      </v-col>
      <v-col :cols="12">
        <h2 v-if="!sidebar" class="text-left step_header" :class="isSidebarToSearchResultsPage() ? 'mt-10 mb-6' : 'mt-0 mt-md-0 ml-0 ml-md-2'">
          {{  $t('search.step_1_header') }}
        </h2>
      </v-col>
      <v-col :cols="12">
        <v-item-group v-if="!sidebar" mandatory selected-class="primary" v-model="materialType" 
          class="text-left mt-4 mb-0 mb-md-11 d-flex justify-space-between flex-md-row flex-column mt-4" :class="isSidebarToSearchResultsPage() ? '' : 'ml-0'">
          <v-item v-for="i in ['mtCell', 'mtSemen']" :key="i" :value="i" v-slot="{ isSelected, selectedClass, toggle }">
            <v-card 
              flat 
              :color="isSelected ? 'primary' : 'white'"
              :class="['d-inline-block material-type flex-grow-1', i == 'mtCell' ? 'mr-0 mr-md-2 mb-2 mb-md-0' : '', selectedClass]" 
              :height="isSidebarResultsPageOrMobile() ? 'auto' : ''"
              @click="toggle">
              <div :class="['text-center', isSidebarResultsPageOrMobile() ? 'mt-6' : 'mt-4 mb-2']">
                <img v-if="i === 'mtCell'"
                  width="64"
                  src="../assets/img/placeholder_female.svg"
                />
                <img v-else
                  width="64"
                  src="../assets/img/placeholder_male.svg"
                />
              </div>
              <div :class="[
                'text-center text-material-type',
                isSidebarResultsPageOrMobile() ? 'mobile pb-6 pt-1' : 'pb-4',
                isSelected ? 'selected' : '',
              ]">
                <span v-if="i === 'mtCell'">
                  {{ $t('search.looking_for_cell_label') }}
                </span>
                <span v-else>
                  {{ $t('search.looking_for_semen_label') }}
                </span>
              </div>
            </v-card>
          </v-item>
        </v-item-group>
      </v-col>
    </v-row>
    <v-row v-if="!sidebar" :class="[$vuetify.display.mobile && filters.length ? 'sticked bottom' : '', 'pa-4','pa-md-0']">
      <v-col :cols="12">
        <h3 v-if="!sidebar" class="text-left step_header_label" :class="isSidebarToSearchResultsPage() ? 'mt-10 mb-6' : 'mt-7 mt-md-0 ml-0 ml-md-2 mb-0'">
          {{  $t('search.step_2_header_label') }}
        </h3>
        <h2 v-if="!sidebar" class="text-left step_header" :class="isSidebarToSearchResultsPage() ? '' : 'ml-0 ml-md-2 mt-0'">
          {{  $t('search.step_2_header') }}
        </h2>
      </v-col>
      <v-col>
        <div class="search_method_wrapper d-flex flex-md-row flex-column justify-space-between mt-4 mb-2">
          <div class="search_method pa-4 mr-0 mr-md-2 mb-2 mb-md-0" @click="search(true)">
            <img src="../assets/svg/database_image.svg" class="search_method_icon" width="64" height="64"/>
            <div class="search_method_title mt-2">{{ $t('search.database_option_header') }}</div>
            <div class="search_method_subtitle mt-2">{{ $t('search.database_option_header_label') }}</div>
          </div>
          <div class="search_method pa-4" @click="search()">
            <img src="../assets/svg/phenotype_image.svg" class="search_method_icon" width="64" height="64"/>
            <div class="search_method_title mt-2">{{ $t('search.phenotype_option_header') }}</div>
            <div class="search_method_subtitle mt-2">{{ $t('search.phenotype_option_header_label') }}</div>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row v-if="sidebar && !showMoreFilters && 'phenotype_eye_color' in aggregations && !store.getters['resultsModule/getSearchForSimilar']" class="text-left mt-0">
      <v-col cols="12" :md="4" class="pa-4">
        <div class="filter_label invicta mb-3 w-100 mt-md-0 mt-4">
          {{$t('search.eye_color_label')}}
          <Tooltip
            class="ml-2 mt-0"
            :text="$t('search.eye_color_tooltip')"
            :icon="true">
          </Tooltip>
        </div>
        <div
          class="filter_wrapper mt-2 d-flex flex-row justify-start invicta"
        >
          <div v-for="(option, index) in 
            sortFilters(aggregations
              .phenotype_eye_color
              .buckets
              .map(bucket => bucket.key), eye_color_list)"
            :key="`${$t('search.eye_color_label')}${index}`"
          :class="$vuetify.display.mobile ? 'filter-mobile' : ''">
            <Tooltip
              :class="['mr-4 mr-md-2', $vuetify.display.mobile ? '' : 'tooltip-short']"
              :text="capitalize($t(`phenotype.eye_color.${materialType}.${option}`))"
              :icon="false">
              <div
                :class="['circle', selectedEyeColors.indexOf(option) > -1 ? 'filter_selected' : '']"
                :id="option"
                @click="toggleFilter(option, 'eye_color')"
              ></div>
            </Tooltip>
          </div>
        </div>
      </v-col>
      <v-col cols="12" :md="4" class="pa-4">
        <div class="filter_label mb-3 w-100 invicta mt-md-0">
          {{$t('search.hair_color_label')}}
          <Tooltip
            class="ml-2 mt-0"
            :text="$t('search.hair_color_tooltip')"
            :icon="true">
          </Tooltip>
        </div>
        <div class="filter_wrapper mt-2 d-flex flex-row justify-start invicta">
          <div v-for="(option, index) in
            sortFilters(aggregations
              .phenotype_hair_color
              .buckets
              .map(bucket => bucket.key), hair_color_list)"
          :key="index"
          :class="$vuetify.display.mobile ? 'filter-mobile' : ''">
            
            <Tooltip
              :class="['mr-4 mr-md-2', $vuetify.display.mobile ? '' : 'tooltip-short']"
              :text="capitalize($t(`phenotype.hair_color.${materialType}.${option}`))"
              :icon="false">
              <div
              :class="['circle', selectedHairColors.indexOf(option) > -1 ? 'filter_selected' : '']"
              :id="option"
              @click="toggleFilter(option, 'hair_color')"
            >
            </div>
            </Tooltip>
          </div>
        </div>
      </v-col>
      <v-col cols="12" :md="4" class="blood_type invicta pa-4">
        <div v-if="'phenotype_blood_type' in aggregations">
          <Tooltip
            :text="$t('search.blood_type_tooltip')"
            :icon="true">
          </Tooltip>
          <MultipleFilterItemGroup :name="$t('search.blood_type_label')" v-model="selectedBloodTypes" :multiple="true"
            :options="aggregations.phenotype_blood_type.buckets"
            :trans-path="`phenotype.blood_type.${materialType}.`" />
        </div>
      </v-col>
      <v-col cols="12" :md="4" class="location pa-4">
        <CustomSelect :name="$t('search.location_header')" v-model="selectedLocationCities" :multiple="true" :flat="false" :options="aggregations.material_location_city.buckets" :chip="false"
        :disabled="selectedLocationCities.includes('ALL')"
        trans-path="" />
      </v-col>

    </v-row>
    <v-row v-if="sidebar && showMoreFilters && !store.getters['resultsModule/getSearchForSimilar']" class="text-left">
      <v-col cols="12" :md="12" class="pb-0 mb-0 mt-5 mt-md-5">
        <div class="filters_header">
          {{ $t('search.filters_header_physical') }}
        </div>
      </v-col>
      <v-col cols="12" :md="4">
        <div class="filter_label invicta mb-3 mt-md-0 w-100">
          {{$t('search.eye_color_label')}}
          <Tooltip
            class="ml-2 mt-0"
            :text="$t('search.eye_color_tooltip')"
            :icon="true">
          </Tooltip>
        </div>
        <div
          class="filter_wrapper mt-2 d-flex flex-row justify-start invicta"
        >
          <div v-for="(option, index) in 
            sortFilters(aggregations
              .phenotype_eye_color
              .buckets
              .map(bucket => bucket.key), eye_color_list)"
            :key="`${$t('search.eye_color_label')}${index}`"
          :class="$vuetify.display.mobile ? 'filter-mobile' : ''">
            <Tooltip
              :class="['mr-4 mr-md-2', $vuetify.display.mobile ? '' : 'tooltip-short']"
              :text="capitalize($t(`phenotype.eye_color.${materialType}.${option}`))"
              :icon="false">
              <div
                :class="['circle', selectedEyeColors.indexOf(option) > -1 ? 'filter_selected' : '']"
                :id="option"
                @click="toggleFilter(option, 'eye_color')"
              ></div>
            </Tooltip>
          </div>
        </div>
      </v-col>
      <v-col cols="12" :md="4">
        <div class="filter_label mb-3 w-100 mt-2 mt-md-0 invicta">
          {{$t('search.hair_color_label')}}
          <Tooltip
            class="ml-2 mt-0"
            :text="$t('search.hair_color_tooltip')"
            :icon="true">
          </Tooltip>
        </div>
        <div class="filter_wrapper mt-2 d-flex flex-row justify-start invicta">
          <div v-for="(option, index) in
            sortFilters(aggregations
              .phenotype_hair_color
              .buckets
              .map(bucket => bucket.key), hair_color_list)"
          :key="index"
          :class="$vuetify.display.mobile ? 'filter-mobile' : ''">
            
            <Tooltip
              :class="['mr-4 mr-md-2', $vuetify.display.mobile ? '' : 'tooltip-short']"
              :text="capitalize($t(`phenotype.hair_color.${materialType}.${option}`))"
              :icon="false">
              <div
              :class="['circle', selectedHairColors.indexOf(option) > -1 ? 'filter_selected' : '']"
              :id="option"
              @click="toggleFilter(option, 'hair_color')"
            >
            </div>
            </Tooltip>
          </div>
        </div>
      </v-col>
      <v-col cols="12" :md="4">
        <div class="filter_label mb-2 w-100 mt-2 mt-md-0 invicta">
          {{$t('search.hair_shape_label')}}
          <Tooltip
            class="ml-2 mt-0"
            :text="$t('search.hair_shape_tooltip')"
            :icon="true">
          </Tooltip>
        </div>
        <div class="filter_wrapper mt-0 d-flex flex-row justify-start invicta">
          <div v-for="(option, index) in 
            sortFilters(aggregations
              .phenotype_hair_structure
              .buckets
              .map(bucket => bucket.key), hair_shape_list)"
              :key="index"
              :class="$vuetify.display.mobile ? 'filter-mobile big' : ''">
            <Tooltip
              :class="['mr-4 mr-md-2', $vuetify.display.mobile ? '' : 'tooltip-short']"
              :text="capitalize($t(`phenotype.hair_structure.${materialType}.${option}`))"
              :icon="false">
              <div
                :class="['circle big mr-4 mr-md-2', selectedHairStructures.indexOf(option) > -1 ? 'filter_selected' : '']"
                :id="option"
                @click="toggleFilter(option, 'hair_structure')"
              >
              </div>
            </Tooltip>
          </div>
        </div>
      </v-col>
      <v-col cols="12" :md="4">
        <div class="filter_label mb-3 w-100 mt-2 mt-md-0 invicta">
          {{$t('search.body_type_label')}}
          <Tooltip
            class="ml-2 mt-0"
            :text="$t('search.body_type_tooltip')"
            :icon="true">
          </Tooltip>
        </div>
        <div class="filter_wrapper mt-2 d-flex flex-row justify-start invicta">
          <div v-for="(option, index) in
            sortFilters(aggregations
              .phenotype_silhouette
              .buckets
              .map(bucket => bucket.key), body_type_list)"
            :key="index"
            :class="$vuetify.display.mobile ? 'filter-mobile-body' : ''">
            <Tooltip
              :class="['mr-4 mr-md-2', $vuetify.display.mobile ? '' : 'tooltip-short']"
              :text="capitalize($t(`phenotype.silhouette.${materialType}.${option}`))"
              :icon="false">
                <div
                  :class="['square mr-2', selectedSilhouettes.indexOf(option) > -1 ? 'filter_selected' : '']"
                  :id="option + (materialType == 'mtSemen' ? '_MALE' : '')"
                  @click="toggleFilter(option, 'silhouette')"
                >
              </div>
            </Tooltip>
          </div>
        </div>
      </v-col>
      <v-col cols="12" :md="4">
        <div class="filter_label mb-3 w-100 mt-8 mt-md-0 invicta">
          {{$t('search.height_label')}}
          <Tooltip
            class="ml-2 mt-0"
            :text="$t('search.height_tooltip')"
            :icon="true">
          </Tooltip>
        </div>
        <div class="filter_wrapper mt-2 d-flex flex-row justify-start">
          <v-text-field label="" color="secondarybg" bg-color="white" v-model="selectedMinHeight" placeholder="Od"
            :persistent-placeholder="true" density="compact" hide-details="auto" variant="outlined" class="mr-1">
            <v-card variant="text" color="primary">{{$t('cm')}}</v-card>
          </v-text-field>
          <v-text-field label="" color="secondarybg" bg-color="white" v-model="selectedMaxHeight" placeholder="Do"
            :persistent-placeholder="true" density="compact" hide-details="auto" variant="outlined" class="ml-1">
            <v-card variant="text" color="primary">{{$t('cm')}}</v-card>
          </v-text-field>
          </div>
      </v-col>
      <v-divider class="my-4" color="secondary300"></v-divider>
      <v-col cols="12" :md="12" class="pb-0 mb-0">
        <div class="filters_header">
          {{ $t('search.filters_header_origins') }}
        </div>
      </v-col>
      <v-col cols="12" :md="4" class="race invicta">
        <CustomSelect :name="$t('search.race_label')" v-model="selectedRace" :multiple="true" :flat="false" :options="aggregations.phenotype_race.buckets" :chip="false"
          :trans-path="`phenotype.race.${materialType}`" />
        <Tooltip
          :text="$t('search.race_tooltip')"
          :icon="true">
        </Tooltip>
      </v-col>
      <v-col cols="12" :md="4" class="skin_color mt-2 mt-md-0 invicta">
          <CustomSelect :name="$t('search.skin_color_label')" v-model="selectedSkinColors" :multiple="true" :flat="false" :options="aggregations.phenotype_skin_color.buckets" :chip="false"
          :trans-path="`phenotype.skin_color.${materialType}`" />
          <Tooltip
            :text="$t('search.skin_color_tooltip')"
            :icon="true">
          </Tooltip>
      </v-col>
      <!-- <v-col cols="12" :md="4">
        <CustomSelect :name="$t('search.ethnicity_label')" v-model="selectedEthnicities" :multiple="true" :flat="false" :options="aggregations.phenotype_ethnicity.buckets"
          :trans-path="`phenotype.ethnicity.${materialType}`" />
      </v-col> -->
      <v-divider class="my-4" color="secondary300"></v-divider>
      <v-col cols="12" :md="12" class="pb-0 mb-0">
        <div class="filters_header">
          {{ $t('search.filters_header_blood') }}
        </div>
      </v-col>
      <v-col cols="12" :md="4" class="blood_type invicta">
        <div v-if="'phenotype_blood_type' in aggregations">
          <Tooltip
            :text="$t('search.blood_type_tooltip')"
            :icon="true">
          </Tooltip>
          <MultipleFilterItemGroup :name="$t('search.blood_type_label')" v-model="selectedBloodTypes" :multiple="true"
            :options="aggregations.phenotype_blood_type.buckets"
            :trans-path="`phenotype.blood_type.${materialType}.`" />
        </div>
      </v-col>

      <v-col cols="12" :md="4" class="rh_factor mt-2 mt-md-0 invicta">
        <div v-if="'phenotype_blood_rh_factor' in aggregations">
          <Tooltip
            :text="$t('search.blood_rh_factor_tooltip')"
            :icon="true">
          </Tooltip>
          <MultipleFilterItemGroup :name="$t('search.blood_fh_factor_label')" v-model="selectedBloodRhFactors" :multiple="true"
            :options="aggregations.phenotype_blood_rh_factor.buckets"
            :trans-path="`phenotype.blood_rh_factor.${materialType}.`" />
        </div>
      </v-col>
    
      <v-divider class="my-4" color="secondary300"></v-divider>
      
      <v-col cols="12" :md="12" class="pb-0 mb-0">
        <div class="filters_header">
          {{ $t('search.filters_header_location') }}
        </div>
      </v-col>
      <v-col cols="12" :md="4" class="location invicta">
        <CustomSelect :name="$t('search.location_header')" v-model="selectedLocationCities" :multiple="true" :flat="false" :options="aggregations.material_location_city.buckets" :chip="false"
        :disabled="selectedLocationCities.includes('ALL')"
        trans-path="" />
      </v-col>

      <v-divider class="my-4" color="secondary300"></v-divider>
      
      <v-col cols="12" :md="12" class="pb-0 mb-0">
        <div class="filters_header">
          {{ $t('search.donor_nickname_header') }}
        </div>
      </v-col>
      <v-col cols="12" :md="4" class="location invicta">
        {{ $t('search.donor_nickname_label') }}
        <div class="search-wrapper">
          <input type="text" class="input search-input" :placeholder="`${$t('eg_short')} Sandra380`" id="lastname" v-model="donorNickname" />
          <v-btn @click="searchDonorNickname" class="search-button"><img src="../assets/svg/icon-search.svg"/></v-btn>
        </div>
        
      </v-col>

    </v-row>
    <v-row v-if="sidebar && !store.getters['resultsModule/getSearchForSimilar']" class="text-left pt-4">
      <v-col cols="12" :md="3" class="d-flex flex-row justify-start">
        <v-btn class="menu-button-plain mb-4 mb-md-0 px-6" color="primary" height="48" rounded
          :width="$vuetify.display.mobile ? '100%' : 'auto'"
          variant="plain"
          flat v-if="sidebar && showMoreFilters" @click="resetAll()">
          {{ $t("search.clear_all_btn") }}
        </v-btn>
        <div v-else>
          <!-- placeholder for space on desktop -->
        </div>
      </v-col>
      <v-col cols="12" :md="6" class="d-flex flex-row justify-start justify-md-center mb-2 mt-md-3">
        <div v-if="sidebar && !showMoreFilters" :class="['text-left more-filters']" @click="showMoreFilters = !showMoreFilters">
          {{ $t('search.show_more_filters') }}
        </div>
        <div v-if="sidebar && showMoreFilters" :class="['text-left more-filters']" @click="showMoreFilters = !showMoreFilters">
          {{ $t('search.show_less_filters') }}
        </div>
      </v-col>
      <v-col cols="12" :md="3" class="d-flex flex-row justify-end">
        <v-btn class="menu-button mb-4 mb-md-0 px-6" color="primary" height="48" rounded
          :width="$vuetify.display.mobile ? '100%' : 'auto'"
          flat v-if="sidebar" @click="search(false)">
          {{ $t('search.filters_action') }}
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
/* eslint-disable */ 
import axios from "axios";
import MultipleFilterItemGroup from "./ItemGroupComponent";
import CustomSelect from "./CustomSelectComponent.vue";
import { Tooltip } from "design-system-ui-components";
import { useStore } from "vuex";
import { computed } from 'vue'
import { eye_color_list, hair_color_list, hair_shape_list, body_type_list } from "../utils/filter_lists";


export default {
  name: 'DonorSearchComponent',
  inheritAttrs: false,
  props: {
    btnShowFiltersName: String,
    btnShowFiltersIcon: String,
    btnShowFiltersClass: String,
    resultsPage: Boolean,
    sidebar: Boolean,
  },
  components: {
    MultipleFilterItemGroup,
    // PhenotypeCompliance,
    Tooltip,
    CustomSelect
  },
  setup() {
    const store = useStore()
    const oidcUser = computed(() => store.getters['oidcStore/oidcUser'])
    return {
      oidcUser: oidcUser
    }
  },
  data: () => ({
    eye_color_list: eye_color_list,
    hair_color_list: hair_color_list,
    hair_shape_list: hair_shape_list,
    body_type_list: body_type_list,
    materialType: useStore().getters['filtersModule/getMaterialType'],
    phenotypeCompliance: useStore().getters['filtersModule/getPhenotypeCompliance'],
    phenotype: useStore().getters['phenotypeModule/getPhenotype'],
    totalRecordCount: 0,
    aggregations: Object,
    isFilterSetting: false,
    isFilterPhenotypeSetting: false,
    filters: useStore().getters['filtersModule/getFilters'],
    donorNickname: useStore().getters["filtersModule/getSelectedValueByField"]('donor_process.donor_nickname')[0],
    selectedEyeColors: useStore().getters["filtersModule/getSelectedValueByField"]('phenotype.eye_color'),
    selectedHairColors: useStore().getters["filtersModule/getSelectedValueByField"]('phenotype.hair_color'),
    selectedHairStructures: useStore().getters["filtersModule/getSelectedValueByField"]('phenotype.hair_structure'),
    selectedSilhouettes: useStore().getters["filtersModule/getSelectedValueByField"]('phenotype.silhouette'),
    selectedBloodTypes: useStore().getters["filtersModule/getSelectedValueByField"]('phenotype.blood_type'),
    selectedBloodRhFactors: useStore().getters["filtersModule/getSelectedValueByField"]('phenotype.blood_rh_factor'),
    selectedRace: useStore().getters["filtersModule/getSelectedValueByField"]('phenotype.race'),
    selectedSkinColors: useStore().getters["filtersModule/getSelectedValueByField"]('phenotype.skin_color'),
    selectedEthnicities: useStore().getters["filtersModule/getSelectedValueByField"]('phenotype.ethnicity'),
    selectedLocationCities: useStore().getters["filtersModule/getSelectedValueByField"]('material.location.city'),
    selectedHeightRange: useStore().getters["filtersModule/getSelectedRangeByField"]('phenotype.height'),
    selectedMinHeight: useStore().getters["filtersModule/getSelectedMinRangeByField"]('phenotype.height'),
    selectedMaxHeight: useStore().getters["filtersModule/getSelectedMaxRangeByField"]('phenotype.height'), 
    validatedHeightRange: true,
    phenotypeAlertVisible: false,
    alertVisible: false,
    store: useStore(),
    selectedProcedure: useStore().getters["filtersModule/getSelectedValueByField"]('material.fitness_for_insemination'),
    showResultsLoginInfoOpen: false,
    showMoreFilters: false,
  }),
  computed: {
    searchQueryParamCellValue: () => 'eggs',
    searchQueryParamSemenValue: () => 'sperm',
  },
  created() {
    if (this.$route.query.search && this.$route.name == 'search') {
      let materialType = '';
      switch (this.$route.query.search) {
        case this.searchQueryParamCellValue:
          materialType = 'mtCell'
          break;
        case this.searchQueryParamSemenValue:
          materialType = 'mtSemen'
          break;
        default:
          materialType = 'mtCell'
          this.$router.push({name: 'search'})
      }
      this.materialType = materialType
      this.store.dispatch('filtersModule/setMaterialType', materialType)
      this.store.dispatch('compareModule/setContext', materialType)
    }

    if (!this.isSidebarToSearchResultsPage()) {
      this.getTotalRecordCount()
    }
    this.$watch('materialType', (materialType) => {
      this.resetAll()
      this.store.dispatch('filtersModule/setMaterialType', materialType)
      this.store.dispatch('compareModule/setContext', materialType)
      this.alertVisible = false;
      this.$root.$alertMessageRef.show = false;

      if (this.$route.query.search && this.$route.name == 'search') {
        if (materialType == 'mtSemen') {
          this.$router.push({name: 'search', query: {search: this.searchQueryParamSemenValue}})
        } else {
          this.$router.push({name: 'search', query: {search: this.searchQueryParamCellValue}})
        }
      }
    })
    this.$watch('donorNickname', (donorNickname) => {
      if (!donorNickname) this.removeFilterByField("donor_process.donor_nickname")
    })
    this.$watch('selectedEyeColors', (eyeColors) => {
      this.removeFilterByField("phenotype.eye_color")
      if (eyeColors.length) this.pushTermsFilter("phenotype.eye_color", eyeColors)
    })
    this.$watch('selectedHairColors', (hairColors) => {
      this.removeFilterByField("phenotype.hair_color")
      if (hairColors.length) this.pushTermsFilter("phenotype.hair_color", hairColors)
    })
    this.$watch('selectedHairStructures', (hairStructures) => {
      this.removeFilterByField("phenotype.hair_structure")
      if (hairStructures.length) this.pushTermsFilter("phenotype.hair_structure", hairStructures)
    })
    this.$watch('selectedHeightRange', (heightRange) => {
      this.selectedMinHeight = heightRange[0]
      this.selectedMaxHeight = heightRange[1]
      this.removeFilterByField("phenotype.height")
      if (this.validatedHeightRange && !this.isFilterSetting) {
        if (this.checkIfIsNotInitialHeightRange()) {
          this.pushRangeFilter("phenotype.height", heightRange)
        }
      }
    })
    this.$watch('selectedMinHeight', (minHeight) => {
      if (!isNaN(minHeight) && minHeight && parseInt(minHeight) <= this.aggregations.phenotype_height.max) {
        this.validatedHeightRange = this.validateHeightRange(parseInt(minHeight), this.selectedHeightRange[1])
        if (this.validatedHeightRange) {
          this.selectedHeightRange = [parseInt(minHeight), this.selectedHeightRange[1]]
        } else {
          this.removeFilterByField("phenotype.height")
        }
      } else if (!this.isFilterSetting) {
        this.selectedHeightRange = [this.aggregations.phenotype_height.min, this.selectedHeightRange[1]]
      }
    })
    this.$watch('selectedMaxHeight', (maxHeight) => {
      if (!isNaN(maxHeight) && maxHeight && parseInt(maxHeight) <= this.aggregations.phenotype_height.max) {
        this.validatedHeightRange = this.validateHeightRange(this.selectedHeightRange[0], parseInt(maxHeight))
        if (this.validatedHeightRange) {
          this.selectedHeightRange = [this.selectedHeightRange[0], parseInt(maxHeight)]
        } else {
          this.removeFilterByField("phenotype.height")
        }
      } else if (!this.isFilterSetting) {
        this.selectedHeightRange = [this.selectedHeightRange[0], this.aggregations.phenotype_height.max]
      }
    })
    this.$watch('selectedSilhouettes', (silhouettes) => {
      this.removeFilterByField("phenotype.silhouette")
      if (silhouettes.length) this.pushTermsFilter("phenotype.silhouette", silhouettes)
    })
    this.$watch('selectedBloodTypes', (bloodTypes) => {
      this.removeFilterByField("phenotype.blood_type")
      if (bloodTypes.length) this.pushTermsFilter("phenotype.blood_type", bloodTypes)
    })
    this.$watch('selectedBloodRhFactors', (bloodRhFactors) => {
      this.removeFilterByField("phenotype.blood_rh_factor")
      if (bloodRhFactors.length) this.pushTermsFilter("phenotype.blood_rh_factor", bloodRhFactors)
    })
    this.$watch('selectedRace', (race) => {
      this.removeFilterByField("phenotype.race")
      if (race.length) this.pushTermsFilter("phenotype.race", race)
    })
    this.$watch('selectedSkinColors', (skinColors) => {
      this.removeFilterByField("phenotype.skin_color")
      if (skinColors.length) this.pushTermsFilter("phenotype.skin_color", skinColors)
    })
    this.$watch('selectedEthnicities', (ethnicities) => {
      this.removeFilterByField("phenotype.ethnicity")
      if (ethnicities.length) this.pushTermsFilter("phenotype.ethnicity", ethnicities)
    })
    this.$watch('selectedLocationCities', (cities) => {
      this.removeFilterByField("material.location.city")
      if (cities.includes('ALL')) {
        if (cities.length > 1) {
          this.selectedLocationCities = ['ALL']
        }
      }
      if (cities.length) this.pushTermsFilter("material.location.city", cities)
    })
    this.$watch('selectedProcedure', (procedure) => {
      this.removeFilterByField("material.fitness_for_insemination")
      if (procedure.length) this.pushTermsFilter("material.fitness_for_insemination", procedure)
    })
    this.$watch('phenotypeCompliance', (type) => {
      this.store.dispatch('filtersModule/setPhenotypeCompliance', type)
      if (type) {
        this.phenotypeAlertVisible = false
        this.$root.$alertMessageRef.show = false;
        this.getRecipientPhenotype(type).then(() => {
          if (this.isSidebarToSearchResultsPage()) {
            this.getResults()
          } else {
            this.getTotalRecordCount()
          }
        })
      }
    })
    this.$watch('filters', (filters) => {

      if (!this.isFilterSetting) {
        if (filters.find(e => e.field == 'donor_process.donor_nickname') && filters.length > 1) {
          this.clearDonorNickname()
        }
      }

      this.store.dispatch('filtersModule/setFilters', filters)
      if (!this.isFilterSetting && !this.isFilterPhenotypeSetting) this.getTotalRecordCount()
      this.phenotypeAlertVisible = false
      this.$root.$alertMessageRef.show = false;

      if (this.phenotypeCompliance && !this.isFilterPhenotypeSetting) {
        this.phenotypeCompliance = null
        this.phenotypeAlertVisible = true
        if(this.$vuetify.display.mobile) {
          document.querySelector('#search-container').scrollTo({top: 0, behavior: 'smooth'});
        } else {
          window.scrollTo({ top: 300, behavior: 'smooth' });
        }
      }
    })
  },
  mounted() {
    this.getAggregations();
  },
  methods: {
    capitalize(text) {
      return text.charAt(0).toUpperCase() + text.slice(1)
    },
    isSidebarToSearchResultsPage() {
      return this.sidebar && this.resultsPage
    },
    isSidebarResultsPageOrMobile() {
      return this.isSidebarToSearchResultsPage() || this.$vuetify.display.mobile
    },
    getAggregations() {
      this.isFilterSetting = true;
      axios
        .get(`/api/donor/filters/${this.materialType}`)
        .then((response) => {
          this.aggregations = response.data.aggregations;  
          // this.aggregations.material_location_city.buckets.push({key: 'ALL'});
          this.setFilterOptionsAndRange();
        })
        .catch(err => {
          console.error(err);
        })
        .finally(() => {
          this.isFilterSetting = false;
          if (this.isSidebarToSearchResultsPage()) {
            this.getResults()
          }
        });
    },
    getTotalRecordCount() {
      if (this.filters.length && this.oidcUser) {
        this.alertVisible = false;
        this.$root.$alertMessageRef.show = false;
        // special flower fitness
        let filters_copy = JSON.parse(JSON.stringify(this.filters))
        // special flower fitness
        let fitness_element = filters_copy.find(e => e.field == 'material.fitness_for_insemination');
        if(fitness_element) {
          switch(fitness_element.value) {
            case 'IUI' : fitness_element.value = ['IUI', 'IUI i ICSI']; break;
            case 'ICSI' : fitness_element.value = ['ICSI', 'IUI i ICSI']; break;
            case 'IUI i ICSI' : fitness_element.value = ['IUI i ICSI']; break;
          }
        }
        filters_copy = filters_copy.filter(e => e.type == 'range' || !e.value.includes('ALL'))
        let request;
        if(this.store.getters['resultsModule/getSearchForSimilar']) {
          request = axios
            .get(`/api/donor/find_matching?material_type=${this.materialType}&limit=10&offset=0`)
        } else {
          request = axios
          .post(`/api/donor/${this.materialType}/data`, {
            "_source": false,
            "script_fields": [
              "age",
              "max_true_reservation_count"
            ],
            "filters": filters_copy
          })
        }
        request
          .then((response) => {
            this.totalRecordCount = response.data.total_count;
          })
          .catch(err => {
            console.error(err);
          })
      } else {
        this.totalRecordCount = 0;
      }
    },
    setFilterOptionsAndRange() {
      if (!this.selectedMinHeight && !this.selectedMaxHeight) {
        this.selectedMinHeight = this.aggregations.phenotype_height.min;
        this.selectedMaxHeight = this.aggregations.phenotype_height.max;
        this.selectedHeightRange = [this.selectedMinHeight, this.selectedMaxHeight];
      }
    },
    checkIfIsNotInitialHeightRange() {
      return this.selectedHeightRange[0] != this.aggregations.phenotype_height.min
        || this.selectedHeightRange[1] != this.aggregations.phenotype_height.max
    },
    validateHeightRange(min, max) {
      if (min >= this.aggregations.phenotype_height.min
        && max <= this.aggregations.phenotype_height.max) {
        if (min <= max) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    resetAll() {
      this.store.dispatch('resultsModule/setSearchForSimilar', false);
      this.isFilterSetting = true;
      this.totalRecordCount = 0;
      this.clearSelectedOptions()
      this.clearDonorNickname()
      this.getAggregations()
    },
    resetFiltersAndSetDonorNickname(donorNickname) {
      this.isFilterSetting = true
      this.clearSelectedOptions()
      this.removeFilterByField("donor_process.donor_nickname")

      if (donorNickname) this.pushTermsFilter("donor_process.donor_nickname", [donorNickname])
      this.getAggregations()
    },
    clearDonorNickname() {
      this.donorNickname = null
      this.removeFilterByField("donor_process.donor_nickname")
    },
    clearSelectedOptions() {
      this.phenotypeCompliance = null;
      this.selectedEyeColors = []
      this.selectedHairColors = []
      this.selectedHairStructures = []
      this.selectedSilhouettes = []
      this.selectedBloodTypes = []
      this.selectedBloodRhFactors = []
      this.selectedRace = []
      this.selectedSkinColors = []
      this.selectedEthnicities = []
      this.selectedLocationCities = []
      this.selectedProcedure = []
      this.selectedMinHeight = 0
      this.selectedMaxHeight = 0
    },
    removeFilterByField(field) {
      this.filters = this.filters.filter(function (element) {
        return element.field != field;
      });
    },
    pushTermsFilter(field, value) {
      this.filters.push({
        "type": "terms",
        "field": field,
        "value": value
      })
    },
    pushRangeFilter(field, value) {
      this.filters.push({
        "type": "range",
        "field": field,
        "value": {
          "gte": value[0],
          "lte": value[1],
        }
      })
    },
    getAlertVisible() {
      return !this.filters.length
    },
    async getRecipientPhenotype(type) {
      this.isFilterPhenotypeSetting = true
      this.clearDonorNickname()
      if (type == 'common') {
        let calculatedPhenotypeBloodTypes = [];
        let calculatedPhenotypeBloodRhFactors = [];
        let femalePhenotype = this.phenotype.own.gender == 'FEMALE' ? this.phenotype.own : this.phenotype.partner;
        let malePhenotype = this.phenotype.own.gender == 'MALE' ? this.phenotype.own : this.phenotype.partner;

        await axios
          .post('/api/blood_calculator/possible_donor?separate_factors=true', {
            "recipient_blood_data": `${femalePhenotype.bloodType}${femalePhenotype.bloodRhFactor=='RH+' ? '+':'-'}`,
            "partner_blood_data": `${malePhenotype.bloodType}${malePhenotype.bloodRhFactor=='RH+' ? '+':'-'}`,
            "material_type": this.materialType
        })
        .then((response) => {
          calculatedPhenotypeBloodTypes = response.data.result.blood_types;
          calculatedPhenotypeBloodRhFactors = response.data.result.blood_rh_factors.map(e => e == '+' ? 'RH+' : 'RH-');
        })
        .catch(err => {
          console.error(err);
        })
        .finally(() => {
          this.setFiltersAccordingToPhenotype(
            femalePhenotype,
            malePhenotype,
            calculatedPhenotypeBloodTypes,
            calculatedPhenotypeBloodRhFactors
          )
        })
      } else {
        await this.setFiltersAccordingToPhenotype(this.phenotype[type],[],[],[])
      }
      this.isFilterPhenotypeSetting = false
    },
    setFiltersAccordingToPhenotype(phenotype, phenotype2, calculatedPhenotypeBloodTypes, calculatedPhenotypeBloodRhFactors) {

      this.selectedEyeColors = phenotype.eyeColor ? [phenotype.eyeColor] : []
      phenotype2.eyeColor ? this.selectedEyeColors.push(phenotype2.eyeColor) : null;
      this.selectedHairColors = phenotype.hairColor ? [phenotype.hairColor] : []
      phenotype2.hairColor ? this.selectedHairColors.push(phenotype2.hairColor) : null;
      this.selectedHairStructures = phenotype.hairShape ? [phenotype.hairShape] : []
      phenotype2.hairShape ? this.selectedHairStructures.push(phenotype2.hairShape) : null;
      this.selectedSilhouettes = phenotype.bodyType ? [phenotype.bodyType] : []
      phenotype2.bodyType ? this.selectedSilhouettes.push(phenotype2.bodyType) : null;
      
      this.selectedBloodTypes = calculatedPhenotypeBloodTypes.length ? calculatedPhenotypeBloodTypes : (phenotype.bloodType ? [phenotype.bloodType] : [])
      this.selectedBloodRhFactors = calculatedPhenotypeBloodRhFactors.length ? calculatedPhenotypeBloodRhFactors : (phenotype.bloodRhFactor ? [phenotype.bloodRhFactor] : [])

      this.selectedRace = []
      if (phenotype.race && this.aggregations.phenotype_race.buckets.find((e) => e?.key == phenotype.race.key)) {
        this.selectedRace.push(phenotype.race)
      }
      if (phenotype2.race && this.aggregations.phenotype_race.buckets.find((e) => e?.key == phenotype2.race.key)) {
        if (!this.selectedRace.find((e) => e?.key == phenotype2.race.key)) {
          this.selectedRace.push(phenotype2.race)
        }
      }

      this.selectedSkinColors = []
      if (phenotype.skinColor && this.aggregations.phenotype_skin_color.buckets.find((e) => e?.key == phenotype.skinColor.key)) {
        this.selectedSkinColors.push(phenotype.skinColor)
      }
      if (phenotype2.skinColor && this.aggregations.phenotype_skin_color.buckets.find((e) => e?.key == phenotype2.skinColor.key)) {
        if (!this.selectedSkinColors.find((e) => e?.key == phenotype2.skinColor.key)) {
          this.selectedSkinColors.push(phenotype2.skinColor)
        }
      }

      this.selectedMinHeight = phenotype.height ? parseInt(phenotype.height) - 10 : null
      this.selectedMaxHeight = phenotype.height ? parseInt(phenotype.height) + 10 : null

      if (phenotype.height && phenotype2.height) {
        if (this.materialType == 'mtSemen') {
          this.selectedMinHeight = parseInt(phenotype2.height) - 10
          this.selectedMaxHeight = parseInt(phenotype2.height) + 10
        }
      }

      let aggrPhenotypeHeight = this.aggregations.phenotype_height;

      if (this.selectedMinHeight < aggrPhenotypeHeight.min || this.selectedMinHeight > aggrPhenotypeHeight.max) {
        this.selectedMinHeight = aggrPhenotypeHeight.min;
      }
      if (this.selectedMaxHeight < aggrPhenotypeHeight.min || this.selectedMaxHeight > aggrPhenotypeHeight.max) {
        this.selectedMaxHeight = aggrPhenotypeHeight.max;
      }
      this.selectedHeightRange = [this.selectedMinHeight, this.selectedMaxHeight]

      // this is separate, because it needs to be cleared
      // but it is not a part of phenotype
      this.selectedProcedure = []
      this.selectedLocationCities = []
    },
    getResults() {
      if (this.oidcUser) {
        this.store.dispatch('resultsModule/setLoading', true);
        let filters_copy = JSON.parse(JSON.stringify(this.filters))
        // special flower fitness
          let fitness_element = filters_copy.find(e => e.field == 'material.fitness_for_insemination');
          if(fitness_element) {
            switch(fitness_element.value) {
              case 'IUI' : fitness_element.value = ['IUI', 'IUI i ICSI']; break;
              case 'ICSI' : fitness_element.value = ['ICSI', 'IUI i ICSI']; break;
              case 'IUI i ICSI' : fitness_element.value = ['IUI i ICSI']; break;
            }
          }
        filters_copy = filters_copy.filter(e => e.type == 'range' || !e.value.includes('ALL'))
        
        let request;
        if(this.store.getters['resultsModule/getSearchForSimilar']) {
          request = axios
            .get(`/api/donor/find_matching?material_type=${this.materialType}&limit=${this.store.getters['resultsModule/getPageSize']}&offset=0`)
        } else {
          request = axios
            .post(`/api/donor/${this.materialType}/data`, {
              "size": this.store.getters['resultsModule/getPageSize'],
              "_source": true,
              "script_fields": [
                "age",
                "max_true_reservation_count"
              ],
              "filters": filters_copy
            })
        }
        request
          .then((response) => {

            let response_data_copy = JSON.parse(JSON.stringify(response.data.data))
            response_data_copy.forEach(e => {
                if(!e.fields.mismatch_factor) {
                  e.fields.mismatch_factor = [1000000]
                }
            })
            this.store.dispatch('resultsModule/setPerfectMatchCount', response.data.perfect_count);
            this.store.dispatch(
              'resultsModule/setResults',
              response_data_copy.map(e => ({
                ...e._source,
                ...e.fields
              }))
            )
            this.store.dispatch('resultsModule/setPageLoaded', 1)
            this.store.dispatch('resultsModule/setTotalRecordCount', response.data.total_count)
          })
          .catch(err => {
            console.error(err);
          })
          .finally(() => {
            this.store.dispatch('resultsModule/setLoading', false);
          })
        }
    },
    search(similar = false) {
      if(similar) {
        this.store.dispatch('resultsModule/setSearchForSimilar', true);
      } else {
        this.store.dispatch('resultsModule/setSearchForSimilar', false);
      }
      if(similar && !this.phenotype.own.gender) {
        if (!this.oidcUser) {
          this.showResultsLoginInfoOpen = true;
        } else {
          this.$router.push({
            name: 'completePhenotypeView',
            params: {
              type: 'own',
            }
          })
        }
      } else if(similar && !this.phenotype.partner.gender) {
        if (!this.oidcUser) {
          this.showResultsLoginInfoOpen = true;
        } else {
          this.$router.push({
            name: 'completePhenotypeView',
            params: {
              type: 'partner',
            }
          })
        }
      } else {
        this.getResults();
        this.alertVisible = false;
        this.$root.$alertMessageRef.show = false;
        if (this.$vuetify.display.mobile && this.resultsPage) {
          window.scrollTo({ top: 0 })
        } else {
          if (!this.oidcUser) {
            this.showResultsLoginInfoOpen = true;
          } else {
            this.$router.push({name: 'resultsView'}).then(() => {
              this.trackCustomEvent()
            })
            window.scrollTo({ top: 0 })
          }
        }
      }
    },
    trackCustomEvent() {
      window._hsq = window._hsq || []
      window._hsq.push(['identify',{ email: this.oidcUser.email }])
      window._hsq.push([
        'trackCustomBehavioralEvent',
        {
          name: process.env.VUE_APP_HS_SEARCH_MATERIAL_TYPE_EVENT_NAME,
          properties: {
            material_type: this.materialType
          }
        },
      ])
    },
    scrollToResults() {
      let resultElements = document.getElementsByClassName('result');
      if (resultElements.length) {
        let firstResultElement = resultElements[0];
        firstResultElement.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    },
    redirect() {
      this.dialog = false;
      
      if (this.$keycloak.authenticated) {
        this.store.dispatch('oidcStore/authenticateOidc', '/results')
      } else {
        this.$router.push({
            name: 'redirect',
            params: {
                mode: 'login',
                pathname: '/results'
            }
        })
      }
    },
    goToRegistration() {
      let currentUrl = window.location.href;
      this.$router.push({
          name: 'redirect',
          params: {
              mode: 'simple',
              pathname: location.pathname,
              url: this.$keycloak.createRegisterUrl({locale: this.$i18n.locale, redirectUri: currentUrl})
          }
      })
    },
    async searchDonorNickname() {
      if (this.donorNickname) {
        await this.resetFiltersAndSetDonorNickname(this.donorNickname)
        if (this.isSidebarToSearchResultsPage()) {
          window.scrollTo({ top: 0 })
        } else {
          this.getTotalRecordCount()
        }
      }
    },
    toggleFilter(option, filter_element) {

      let filter = null;

      switch(filter_element) {
        case 'eye_color': filter = this.selectedEyeColors; break;
        case 'hair_color': ; filter = this.selectedHairColors; break;
        case 'hair_structure': filter = this.selectedHairStructures; break;
        case 'silhouette': ; filter = this.selectedSilhouettes; break;
      }

      if (filter.indexOf(option) < 0) {
        filter.push(option);
      } else {
        filter.splice(filter.indexOf(option),1);
      }

      this.removeFilterByField(`phenotype.${filter_element}`)
      if (filter.length) this.pushTermsFilter(`phenotype.${filter_element}`, filter)

    },
    sortFilters(list, data) {
      return list.sort((a,b) => {
        if (data[a] && data[b]) return data[a] > data[b] ? 1 : -1;
        else if(data[a] && !data[b]) return 1;
        else return -1;
      })
    }
  }
}
</script>
<style lang="scss" scoped>

.more-filters {
    @include nsb-font-container-medium;
    font-size: 14px;
    line-height: 21px;
    text-decoration: underline;
    cursor: pointer;
  }
  .filter-mobile {
    width: 48px;
    height: 40px;
  }
  .filter-mobile-body {
    width: 60px;
    height: 32px;
  }

  .search-wrapper {
    position: relative;
    .search-input {
      color: red;
    }
    .search-button {
      position: absolute;
      right: 0px;
      height: 100%;
      width: 40px;
      border: none;
      box-shadow: none;
      background: transparent;
      color: var(--bank-primary, #00205B);
      cursor: pointer;
      &:hover {
        background: transparent;
        color: var(--bank-primary, #00205B);
        border: none;
        box-shadow: none;
      }
    }
  }
  .tooltip-short {
    display: block;
    position: relative;
    :deep(.tooltip--bubble) {
      min-width: 50px;
      height: 56px;
      position: absolute;
      top:64px;
      background-color: var(--bank-primary, #00205B);
      color: white;
      transform: translateX(calc(-50% + 4px));
      margin-top: 12px;
      margin-top: 0px;
    }
    :deep(.tooltip--text) {
      white-space: nowrap;
      &::after {
        display: block;
        width: 24px;
        height: 12px;
        position: absolute;
        left: 50%;
        top: -12px;
        transform: translateX(-50%);
        background-image: url(../assets/img/triangle.png);
      }
    }
  }
</style>
<style lang="scss" scoped>
@import "../../node_modules/design-system-ui-components/dist/all.min.css";

.blood_type, .rh_factor, .race, .skin_color, .location {
  position: relative;
  :deep(.tooltip--container) {
    position: absolute;
    top: 12px;
    .icon {
      margin-top: -2px !important;
      width: 24px !important;
      height: 24px !important;
    }
  }
}
.blood_type {
  :deep(.tooltip--container) {
    left: 98px;
  }
}
.rh_factor {
  :deep(.tooltip--container) {
    left: 98px;
  }
}
.race {
  :deep(.tooltip--container) {
    left: 58px;
  }
}
.skin_color {
  :deep(.tooltip--container) {
    left: 98px;
  }
}
.location  {
  :deep(.tooltip--container) {
    left: 98px;
  }
}

.search-header {
  .search-header-main {
    @include nsb-gentium-bold;
    font-size: 28px;
    font-style: normal;
    font-weight: 500;
    line-height: 130%; /* 36.4px */
  }
  .search-header-sub {
    @include nsb-font-container;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 23px; /* 164.286% */
  }
}



.step_header {
  @include nsb-gentium-bold;
  font-size: 23px;
  font-style: normal;
  // font-weight: 700;
  font-weight: normal;
  line-height: 145%; /* 33.35px */
}
.step_header_label {
  @include nsb-font-container;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 150% */
}

.choose_material_header {
  @include nsb-gentium-bold;
  font-size: 28px;
  font-style: normal;
  // font-weight: 700;
  line-height: 140%; /* 39.2px */
}

.choose_material_header_label {
  @include nsb-font-container;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px; /* 157.143% */
}

.menu-button-plain {
  opacity: 1;
  border: 1px solid $ds-primary;
}
.show-filters-button {
  background: transparent !important;
  color: $ds-primary !important;
  border: 1px solid transparent;
  text-decoration: underline;
  opacity: 1;
  &:hover {
    background: transparent !important;
    border: 1px solid $ds-primary;
  }
}

.filters_header {
  color: var(--bank-primary, #00205B);
  @include nsb-gentium-bold;
  font-size: 23px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%; /* 33.35px */
  position: relative;
}

.filters_header_label {
  color: var(--bank-primary, #00205B);
  @include nsb-font-container;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 150% */
}

.v-col {
  margin: 0 !important;
  padding: 0 !important;
}

.filter_label {
  color: var(--nsb-color-1, #0E346F);
  @include ds-font-label-medium;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  :deep(.tooltip--container) {
    display: inline-block;
    .icon {
      margin-top: -1px !important;
      width: 24px !important;
      height: 24px !important;
    }
  }
}

.square {
  width: 48px;
  height: 48px;
  border-radius: 4px;
  &:hover {
    box-shadow: 0px 0px 5px 2px inset var(--nsb-color-1, #0E346F);
    cursor: pointer;
  }
  &[id='ECTOMORPH_BODY_TYPE'] { // thin
    background: url('../assets/svg/thin.svg');
    background-size: cover;
    &.filter_selected {
      background: url('../assets/svg/thin-selected.svg');
      background-size: contain;
    }
  }
  &[id='MESOMORPH_BODY_TYPE'] { // middle
    background: url('../assets/svg/medium.svg');
    background-size: cover;
    &.filter_selected {
      background: url('../assets/svg/medium-selected.svg');
      background-size: contain;
    }
  }
  &[id='ENDOMORPH_BODY_TYPE'] { // thick
    background: url('../assets/svg/thick.svg');
    background-size: cover;
    &.filter_selected {
      background: url('../assets/svg/thick-selected.svg');
      background-size: contain;
    }
  }
  &[id='ECTOMORPH_BODY_TYPE_MALE'] { // thin
    background: url('../assets/svg/thin_male.svg');
    background-size: cover;
    &.filter_selected {
      background: url('../assets/svg/thin-selected_male.svg');
      background-size: contain;
    }
  }
  &[id='MESOMORPH_BODY_TYPE_MALE'] { // middle
    background: url('../assets/svg/medium_male.svg');
    background-size: cover;
    &.filter_selected {
      background: url('../assets/svg/medium-selected_male.svg');
      background-size: contain;
    }
  }
  &[id='ENDOMORPH_BODY_TYPE_MALE'] { // thick
    background: url('../assets/svg/thick_male.svg');
    background-size: cover;
    &.filter_selected {
      background: url('../assets/svg/thick-selected_male.svg');
      background-size: contain;
    }
  }
}
.filter_selected {
  box-shadow: 0px 0px 2px 2px var(--nsb-color-1, #0E346F);
}
.circle {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 2px solid white !important;
  &:hover {
    box-shadow: 0px 0px 2px 2px inset var(--nsb-color-1, #0E346F);
    cursor: pointer;
  }
  &.big {
    width: 32px;
    height: 32px;
    cursor: pointer;
  }

  &[id='BLUE_EYE_COLOR'] {
    background-color: #779ec7;
  }
  &[id='BROWN_EYE_COLOR'] {
    background-color: #351f18;
  }
  &[id='GREEN_EYE_COLOR'] {
    background-color: #4a633a;
  }
  &[id='GREY_EYE_COLOR'] {
    background-color: #7f9991;
  }
  &[id='BLACK_EYE_COLOR'] {
    background-color: #452e1b;
  }
  &[id='HAZEL_EYE_COLOR'] {
    background-color: #a35c16;
  }
  &[id='RED_EYE_COLOR'] {
    background-color: #a04152;
  }
  &[id='HETEROCHROMIA_EYE_COLOR'] {
    background: linear-gradient(45deg,
      #779ec7 0%,
      #779ec7 50%,
      #a35c16 50%,
      #a35c16 100%
    )
  }
  &[id='ALBINISM_HAIR_COLOR'] {
    background-color: #CBCBCB;
  }
  &[id='BLACK_HAIR_COLOR'] {
    background-color: #141213;
  }
  &[id='BLOND_HAIR_COLOR'] {
    background-color: #e3ccae;
  }
  &[id='BROWN_HAIR_COLOR'] {
    background-color: #452e1b;
  }
  &[id='CHESTNUT_HAIR_COLOR'] {
    background-color: #5e2f26;
  }
  &[id='DARK_BLOND_HAIR_COLOR'] {
    background-color: #97764f;
  }
  &[id='RED_HAIR_COLOR'] {
    background-color: #cd5816;
  }
  &[id='CURLY_HAIR_SHAPE'] {
    background: url('../assets/svg/curly-hair.svg');
    background-size: contain;
    &.filter_selected {
      background: url('../assets/svg/curly-hair-selected.svg');
      background-size: contain;
    }
  }
  &[id='STRAIGHT_HAIR_SHAPE'] {
    background: url('../assets/svg/straight-hair.svg');
    background-size: contain;
    &.filter_selected {
      background: url('../assets/svg/straight-hair-selected.svg');
      background-size: contain;
    }
  }
  &[id='WAVE_HAIR_SHAPE'] {
    background: url('../assets/svg/wavy-hair.svg');
    background-size: contain;
    &.filter_selected {
      background: url('../assets/svg/wavy-hair-selected.svg');
      background-size: contain;
    }
  }
}

.search_method_wrapper {
  // * {
  //   box-shadow: 0px 0px 1px red inset;
  // }
  .search_method {
    max-width: 50%;
    border: 1px solid rgb(227, 236, 248);
    border-radius: 4px;
    &:hover {
      border: 1px solid var(--ds-background-00, #F7F7F7);
      background: var(--ds-background-00, #F7F7F7);
    }
    @include ds-font-label-medium;
    .search_method_title {
      color: var(--ds-primary, #00205B);
      text-align: center;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
    .search_method_subtitle {
      color: var(--ds-primary-02, #375C92);
      text-align: center;
      font-size: 10px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
  }
}

.show-results-login-modal {
  .modal {
    &-header {
      @include nsb-font-main-header;
      font-size: 23px !important;
    }
    &-text {
    @include nsb-font-container;
      font-size: 14px !important;
      line-height: 21px !important;
    }
    &-buttons {
      @include nsb-font-button;
      line-height: 21px !important;
    }
  }
}
.tooltip_position {
  margin-top: 2px;
  display: inline-block;
}
.tooltip_position_field_blood {
  margin-top: 2px;
  position: absolute;
  left: 90px;
}
.tooltip_position_field_procedure {
  margin-top: 2px;
  position: absolute;
  left: 90px;
}
.tooltip_position_field_mobile {
  margin-top: 2px;
  position: absolute;
  left: 90px;
}
.tooltip_mobile {
  max-width: 24px;
}
:deep(.v-slider-thumb) {
  width: 16px;
  height: 16px;
  // background: url(../assets/img/thumb.png);
  background-image: url(../assets/svg/thumb.svg);
  background-position: center center;
  background-repeat: no-repeat;
  box-shadow: none !important; 
}
:deep(.v-slider-thumb__surface) {
  box-shadow: none !important;
  display: none;
}
:deep(.v-slider-thumb__ripple) {
  box-shadow: none !important;
  display: none;
}
:deep(.v-slider-track) {
  height: 2px !important;
}

h2 {
  @include nsb-font-main-header;
  font-size: 28px;
  line-height: 32px;
}
h3 {
  @include nsb-font-header-medium;
  font-size: 14px;
  // color: $ds-primary;
}
h4 {
  @include nsb-font-header-bold;
  font-size: 16px;
}

.sidebar {
  h2 {
    font-size: 23px;
    line-height: 27px;
  }
}

#search-container {
  background: white;
}
.sticked {
  position: fixed;
  width: 100%;
  z-index: 1;
  background: $ds-white;

  &.top {
    top: 0px;
    left: 0px;
  }

  &.bottom {
    bottom: 12px;
    left: 12px;
  }
}

.v-card {
  &.material-type {
    // width: calc((100% - 8px)/2);
    min-width: 126px;
    // max-width: 280px;
    box-sizing: border-box;
    border: 1px solid $ds-secondary-300;

    i.v-icon {
      &.selected {
        background-color: $ds-white;
      }
    }

    &.primary {
      border: 0 !important;
      padding: 1px !important;
    }

    .text-material-type {
      @include nsb-font-container-medium;
      font-size: 12px;
      line-height: 18px;
      min-width: 280px;
      color: $ds-primary;
      &.mobile {
        @include nsb-font-container;
        min-height: 74px;
        min-width: 126px;
        font-size: 14px;
        line-height: 21px;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      &.selected {
        color: $ds-white;
      }
    }
  }
}
.sub-alert {
  border: 1px solid rgb(255, 230, 100);
}
.v-slider-thumb__ripple {
  border: 4px solid $ds-white;
  border-radius: 16px;
  box-shadow: 4px 4px 16px rgba(185, 185, 185, 0.25);
}

.v-card, .v-divider {
  border-color: $ds-secondary-300;
}

:deep(.v-field--variant-outlined) {
  .v-field__outline {
    --v-field-border-opacity: 1;
    color: $ds-secondary-300;
    .v-field__outline__start {
      --v-field-border-width: 1px;
    }
    .v-field__outline__end {
      --v-field-border-width: 1px;
    }
  }
}
:deep(.v-field__input) {
  .v-card {
    @include nsb-font-input;
    position: absolute;
    right: 16px;
    top: 9px;
  }
}

@media (max-width: 960px) {
  h2 {
    font-size: 23px;
    line-height: 27px;
  }

  button#reset {
    @include nsb-font-button-medium;
    opacity: 1;
    position: fixed;
    top: 0px;
    left: 0px;
    padding: 0px;
    z-index: 2;
    font-size: 12px !important;
    line-height: 18px !important;
    color: $ds-primary !important;
    text-decoration: underline;
    text-transform: none;
  }

  .search_method_wrapper {
    .search_method {
      max-width: 100%;
    }
  }
}
.procedure, .blood_type {
  position: relative;
}

@media (min-width: 960px) {
  .search-header {
    .search-header-main {
      @include nsb-gentium-bold;
      font-size: 56px;
      font-style: normal;
      font-weight: 500;
      line-height: 120%; /* 67.2px */
      letter-spacing: -0.224px;
    }
    .search-header-sub {
      @include nsb-font-container;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 26px; /* 162.5% */
    }
  }
  .circle {
    width: 24px;
    height: 24px;
    &:hover {
      box-shadow: 0px 0px 2px 2px inset var(--nsb-color-1, #0E346F);
    }
  }
  .v-container {
    max-width: 996px !important;
    z-index: 100;
    margin-bottom: 40px;
    background: $ds-white;
    align-items: center !important;
  }
  .sidebar {
    .v-container {
      box-shadow: none;
      border-radius: 0px;
      padding: 0px;
    }
  }
  button#reset {
    opacity: 1;
    &.sidebar-results {
      @include nsb-font-button-medium;
      position: absolute;
      top: 10px;
      right: -16px;
      padding: 0px;
      font-size: 12px !important;
      line-height: 18px !important;
      text-decoration: underline;
      text-transform: none;
    }
  }

  :deep(.v-field) {
    width: 280px;
  }
  .procedure, .blood_type {
    position: relative;
  }
}
</style>